import type { Call } from '@entities/call';
import type { BaseUsecase } from '@usecases/base-usecase';

export type RejectIncomingCallRequest = {
  callId: string;
};

export interface RejectIncomingCallRepository {
  fetchCallById(id: string): Promise<Call | undefined>;
  removeCalls(): Promise<void>;
}

export interface RejectIncomingCallEventPublisher {
  publish(): Promise<void>;
}

export interface RejectIncomingCallUsecase
  extends BaseUsecase<RejectIncomingCallRequest, Call | void> {
  run(call: RejectIncomingCallRequest): Promise<Call | void>;
}

export class RejectIncomingCall implements RejectIncomingCallUsecase {
  constructor(
    private repository: RejectIncomingCallRepository,
    private publisher: RejectIncomingCallEventPublisher,
  ) {}

  async run(req: RejectIncomingCallRequest): Promise<Call | void> {
    const call = await this.repository.fetchCallById(req.callId);
    await Promise.all([
      this.publisher.publish(),
      this.repository.removeCalls(),
    ]);
    return call;
  }
}
